import { render, staticRenderFns } from "./Subcomment.vue?vue&type=template&id=60eca346&scoped=true&"
import script from "./Subcomment.vue?vue&type=script&lang=js&"
export * from "./Subcomment.vue?vue&type=script&lang=js&"
import style0 from "./Subcomment.vue?vue&type=style&index=0&id=60eca346&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eca346",
  null
  
)

export default component.exports